import {IconButton} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import IranFlag from "../../assets/images/iran.webp";
import api from "../../api";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import moment from "moment-jalaali";
import LoadingSpinner from "../Loading";
import {toast} from "react-toastify";
import {Delete} from "@material-ui/icons";
import {e2p, p2e} from "../../utils/utils";


function ExtraTool() {
    const [car, setCar] = useState(null);
    const [extraTools, setExtraTools] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [newExtraTool, setNewExtraTool] = useState({
        name: '',
        price: 0,
        description: '',
    });

    const {carId} = useParams();
    const {requestId} = useParams();

    const handleCreateExtraTool = async (e) => {
        e.preventDefault();
        
        const price = p2e(newExtraTool.price);
        
        if (!parseInt(price)) {
            toast.error('لطفا مبلغ را به عدد وارد کنید.', {
                toastId: 'invalid-price'
            });
            return;
        }
        
        setIsLoading(true);
        const requestData = {
            name: newExtraTool.name,
            price: price,
            description: newExtraTool.description,
            repair_request_id: requestId,
        }

        try {
            const response = await api.post('/extra-tool', requestData);
            toast.success('لوازم یدکی با موفقیت اضافه شد.');
            setExtraTools([...extraTools, response.data.data]);
            setNewExtraTool({
                name: '',
                price: 0,
                description: '',
            });
        } catch (error) {
            toast.error(error.response.data.message)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setIsLoading(true);

        async function fetchExtraTools() {
            const response = await api.get(`/repair-request/extra-tools/${requestId}`);
            const extraTools = response.data.data
            if (extraTools.length > 0)
                extraTools.map((extraTool) => {
                    extraTool['createdAt'] = moment(extraTool.date)
                        .locale('fa')
                        .format('jYYYY/jMM/jDD HH:mm');
                })
            setIsLoading(false);
            setExtraTools(extraTools)
        }

        fetchExtraTools();

        async function fetchCar() {
            setIsLoading(true);
            const response = await api.get(`/car/${carId}`);
            setCar(response.data.data);
            if (car !== null) {
                setIsLoading(false);
            }

        }

        fetchCar();

    }, []);

    const handleDeleteClick = (extraToolId) => {
        setIsLoading(true);
        api.delete(`/extra-tool/${extraToolId}`)
            .then(response => {
                setIsLoading(false);
                toast.success('لوازم یدکی موردنظر با موفقیت حذف شد.')
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch(error => {
                toast.error(error.response.data.message)
            });
    };

    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        {car &&
                            <div className="row d-block justify-content-center g-0">
                                <div className="row mx-auto pelak g-0 mb-3 mt-3" style={{width: '20rem'}}>
                                    <div className="col">
                                        <div className="row my-auto">
                                            <div className="col border-start border-end-0">
                                                <p className="text-center fw-bold iranNo">ایران</p>
                                                <div>
                                                    <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                                </div>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                            </div>
                                            <div className="col my-auto">
                                                <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto leftSide">
                                        <div className="flag">
                                            <img src={IranFlag} alt="iran's flag"/>
                                        </div>
                                        <div className="iranText text-center">
                                            <p>I.R.</p>
                                            <p>IRAN</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {car &&
                            <div className="row justify-content-center">
                                <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                    <div className="card rounded-4 border-3 border-dark mb-4">
                                        <h5 className="card-header bg-dark text-white text-center">افزودن لوازم
                                            یدکی</h5>
                                        <div className="card-body">
                                            <form action="">
                                                <div className="mb-3">
                                                    <label htmlFor="name" className="form-label">شرح فاکتور</label>
                                                    <input
                                                        required
                                                        type="text"
                                                        id="name"
                                                        className="form-control shadow"
                                                        name="name"
                                                        maxLength="50"
                                                        value={newExtraTool.name}
                                                        onChange={(e) => {
                                                            setNewExtraTool({
                                                                ...newExtraTool,
                                                                name: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="price"
                                                           className="form-label text-center">مبلغ</label>
                                                    <input
                                                        required
                                                        type="text"
                                                        maxLength={15}
                                                        id="price"
                                                        className="form-control shadow"
                                                        name="price"
                                                        value={newExtraTool.price}
                                                        onChange={(e) => {
                                                            setNewExtraTool({
                                                                ...newExtraTool,
                                                                price: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </div>

                                                <div className="d-grid gap-2">
                                                    <input
                                                        type="submit"
                                                        className="btn btn-warning me-1"
                                                        name="submit"
                                                        value="ثبت"
                                                        onClick={handleCreateExtraTool}
                                                        disabled={isLoading}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                        <h5 className="card-header bg-dark text-white text-center">لیست لوازم یدکی</h5>
                                        <div className="card-body">
                                            <table className="table table-bordered mb-0">
                                                {extraTools.map((extraTool, index) => (
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{extraTool.name}</td>
                                                        <td className="text-center">{e2p(extraTool.createdAt).replace(' ', ' - ')}</td>
                                                        <td className="text-center">{e2p(extraTool.price?.toLocaleString()) ?? ''}</td>
                                                        <td className="text-center">
                                                            <IconButton disabled={isLoading}
                                                                        onClick={() => handleDeleteClick(extraTool.id)}>
                                                                <Delete color="secondary"/>
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 d-grid gap-2">
                                            <input
                                                type="button"
                                                className="btn btn-info"
                                                name="button1"
                                                value="گزارشات"
                                                onClick={() => {
                                                    window.location.href = `/reports`
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default ExtraTool;
